import React from 'react';
import { Helmet } from 'react-helmet';
import Hero from './../components/Hero';
import banner from '../assets/packagebanner.png';
import PackagesSection from '../components/PackagesSection';
import MembershipQuoteForm from './../components/MembershipQuoteForm';
import FrequentlyVisitedMakes from './../components/FrequentlyVisitedMakes';
import { useNavigate } from 'react-router-dom';

const Packages = () => {

  const navigate = useNavigate();
  const handleServicesClick = () => {
    navigate('/contact');
  };
  return (
    <div>
      <Helmet>
        <link rel="canonical" href="https://driveincarspa.com/packages" />
        <title>Top Full Car Spa Near Me | Interior & Exterior Detailing Experts | Drive-in Car Spa</title>
        <meta name="description" content="Find the best full car spa service near you. Complete interior and exterior detailing, stain removal, and polishing for a fresh, clean, and glossy finish." />
        <meta name="keywords" content=" Best car detailing packages in Bangalore, car detailing services near me, Professional Car Detailing, Full car spa service near me
" />
        <meta name="author" content="DriveIn Team" />
      </Helmet>
      <Hero
      title={
  <>
    <span className="highlight">Pick Your Package, Pamper</span><br />
    Your Ride – Full Car Spa Service Near Me
  </>
}
subtitle="Choose Your Shine. Drive in Today."
        bgImage={banner}
       onButtonClick={handleServicesClick}
        buttonText="Contact Us"
      />
      <PackagesSection />
      <MembershipQuoteForm/>
      <FrequentlyVisitedMakes/>
    </div>
  );
};

export default Packages; 